var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3V0.75C12 0.335859 11.6641 0 11.25 0H9C8.58586 0 8.25 0.335859 8.25 0.75H3.75C3.75 0.335859 3.41414 0 3 0H0.75C0.335859 0 0 0.335859 0 0.75V3C0 3.41414 0.335859 3.75 0.75 3.75V8.25C0.335859 8.25 0 8.58586 0 9V11.25C0 11.6641 0.335859 12 0.75 12H3C3.41414 12 3.75 11.6641 3.75 11.25H8.25C8.25 11.6641 8.58586 12 9 12H11.25C11.6641 12 12 11.6641 12 11.25V9C12 8.58586 11.6641 8.25 11.25 8.25V3.75C11.6641 3.75 12 3.41414 12 3ZM9.75 1.5H10.5V2.25H9.75V1.5ZM1.5 1.5H2.25V2.25H1.5V1.5ZM2.25 10.5H1.5V9.75H2.25V10.5ZM10.5 10.5H9.75V9.75H10.5V10.5ZM9.75 8.25H9C8.58586 8.25 8.25 8.58586 8.25 9V9.75H3.75V9C3.75 8.58586 3.41414 8.25 3 8.25H2.25V3.75H3C3.41414 3.75 3.75 3.41414 3.75 3V2.25H8.25V3C8.25 3.41414 8.58586 3.75 9 3.75H9.75V8.25Z",
    fill: "#4A3F2F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSize);
export default __webpack_public_path__ + "static/media/size.759766cc613cee62ca2e8af0abc5fe96.svg";
export { ForwardRef as ReactComponent };